import { isBedbankOffer, isLEOffer } from 'lib/offer/offerTypes'
import type { IntlShape } from 'react-intl'

export interface OfferDisplayData {
  propertyName: string
  packageName?: string
  location: string
  imageId?: string
}

export function extractOfferDisplayData(offer: App.AnyOffer, intl?: IntlShape): OfferDisplayData {
  let propertyName = offer.name || (intl?.formatMessage({
    id: '56OfDssfnjReKJJVmVpv',
    defaultMessage: 'Hotel',
    description: 'Fallback property name when offer has no name in the customer support assistant',
  }) ?? 'Hotel')
  if (isLEOffer(offer) && offer.property?.name) {
    propertyName = offer.property.name
  }

  const packageName = offer.name !== propertyName ? offer.name : undefined

  let location = ''

  if (isLEOffer(offer)) {
    const heading = offer.locationHeading
    const subheading = offer.locationSubheading
    if (heading || subheading) {
      location = [heading, subheading].filter(Boolean).join(', ')
    }
  }

  // Fallback for bedbank offers
  if (!location && isBedbankOffer(offer)) {
    if (offer.property?.address) {
      const { city, stateProvinceName } = offer.property.address
      if (city || stateProvinceName) {
        location = [city, stateProvinceName].filter(Boolean).join(', ')
      }
    }
  }

  let imageId: string | undefined
  if ('images' in offer && offer.images.length > 0) {
    imageId = offer.images[0].id
  } else if ('image' in offer && offer.image) {
    imageId = offer.image.id
  }

  return { propertyName, packageName, location, imageId }
}
